import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { CONSTANTS } from 'src/Core/Constant';

@Component({
  selector: 'app-change-state-modal',
  templateUrl: './change-state-modal.component.html',
  styleUrls: ['./change-state-modal.component.scss']
})
export class ChangeStateModalComponent {

  public data: any;
  stateOptions: any[] = [];
  userData: any = {};
  changeStateForm!: FormGroup;
  submitted = false;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private api: SevaProfileService,
    protected dialogRef: NbDialogRef<any>
  ) {
    this.data = this.dialogRef;
  }

  ngOnInit() {
    const contextData = this.data.data || this.data;
    this.stateOptions = contextData.stateOptions || [];
    this.userData = contextData.userData || {};
    this.initializeForm();
  }

  initializeForm() {
    this.changeStateForm = this.fb.group({
      decisionOutcome: ['', Validators.required],
      comment: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10000)]],
      ApplicationGuid: [this.userData.ApplicationGuid],
      SevaProfileDisplayUID: [this.userData.SevaProfileDisplayUID],
    });
  }

  changeState() {
    if (this.changeStateForm.invalid) {
      this.submitted = true;
      this.changeStateForm.markAllAsTouched();
      return;
    }

    this.submitted = false;

    const formValue = this.changeStateForm.value;
    let requestBody = {
      ApplicationGuid: formValue.ApplicationGuid,
      SevaProfileDisplayUID: formValue.SevaProfileDisplayUID,
      FinalRemarks: formValue.comment,
      DecisionOutcome: formValue.decisionOutcome
    };

    const endPoint = 'GAO/Finalize';

    this.api.apiCall(endPoint, 'POST', requestBody).subscribe({
      next: (response: any) => {
        if (response.Data) {
          this.dialogRef.close(true);
        }
      },
      error: (error) => {
        console.error('API Error:', error);
        this.toastr.error(error.error?.Message || 'An error occurred while changing the state.');
        this.dialogRef.close(false);
      }
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
